import React, { useEffect } from 'react';
import { Body, Header } from '../Components';
import Snackbar from '../Components/Common/Snackbar';
import ErrorPage from '../Pages/Error';
import { useMessages } from '../contexts';

export default function PageLayout({ children }) {
  const { message, type, clearMessage, clearPageError, pageLoading, pageFetching, pageError } =
    useMessages();

  useEffect(() => {
    clearPageError();
  }, [clearPageError]);

  const loading = pageLoading;

  return (
    <>
      <Header />
      <Body loading={loading} fetching={pageFetching}>
        {pageError ? <ErrorPage type={pageError} /> : children}
      </Body>
      <Snackbar type={type} open={Boolean(message)} onClose={clearMessage}>
        <>{message}</>
      </Snackbar>
    </>
  );
}
